import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { GridMetadata } from '../../../constants/grid-meta.constants';
import { UserService } from '../../../services/user.service';
import { OverrideStatusEnum } from '../../../constants/override-status.enum';
import { GridTypeEnum } from '../../../constants/grid-type.enum';
import { ToastrService } from 'ngx-toastr';
import { GridResultEnum } from '../../../constants/grid-result.enum';
import { GridResultService } from '../../../services/gridresult.service';
import { IGlobalEmployeeDetailModel } from '../../../entities-api/IGlobalEmployeeDetailModel';
import { IGlobalEmployeeDetailGridDataModel } from '../../../entities-api/IGlobalEmployeeDetailGridDataModel';
import { IContainerMappingDetailGridDataModel } from '../../../entities-api/IContainerMappingDetailGridDataModel';
import { IBaseMappingDetailGridDataModel } from '../../../entities-api/IBaseMappingDetailGridDataModel';
import { IOnboardedAppGridModel } from '../../../entities-api/IOnboardedAppGridModel';
import { DownloadExcel } from '../../../../enum/downloadExcel';
import { ExportExcelService } from '../../../services/export-excel-service';
@Component({
  selector: 'opm-grid',
  templateUrl: './opm-grid.component.html',
  styleUrls: ['./opm-grid.component.less'],
  standalone: false
})
export class OpmGrid implements OnChanges {

  constructor(
    private userService: UserService,
    private gridtype: GridResultService,
    private toasterService: ToastrService,
    private exportExcelService: ExportExcelService
  ) {
  }
  excelEnum = DownloadExcel;
  @Input() metaName: string;
  @Output() userSyncAction = new EventEmitter();
  gridresult: string = this.gridtype.gridResult;
  @Input() users: IGlobalEmployeeDetailModel[];
  @Input() totalRecords: number;
  @Input() containerMapping: IContainerMappingDetailGridDataModel[];
  @Input() baseMapping: IBaseMappingDetailGridDataModel[];
  @Input() onBoardedApps: IOnboardedAppGridModel[];
  @Input() isEnabledFilter: Boolean;

  overrideStatusEnum = OverrideStatusEnum;
  gridTypeEnum = GridTypeEnum;
  gridResultEnum = GridResultEnum;
  metadata: Array<any> = [];

  visiblMessagePopup: boolean = false;
  isAudit: boolean;
  errorMessage: string;
  visiblErrorPopup: boolean = false;
  readOnlyAccessData: boolean = false;
  readWriteAccessData: boolean = false;
  ngOnInit(): void {
    this.userService.getReadOnlyAccessData().then((response) => {
      this.readOnlyAccessData = response;
    })
    this.userService.getWriteAccessData().then((response) => {
      this.readWriteAccessData = response;
    })
  }
  ngOnChanges(): void {
    if (this.metaName) {
      this.metadata = GridMetadata[this.metaName]();
      this.isAudit = this.metaName === this.gridTypeEnum.Audit;
    }
  }

  revert(user: IGlobalEmployeeDetailModel): void {
    if (this.readWriteAccessData == true) {
      if (user.HasErrors) {
        this.visiblMessagePopup = false;
        return;
      }

      this.userService.revertOverride(user.GlobalPersonUid).then(() => {
        this.userService.getUsers().then((data: IGlobalEmployeeDetailGridDataModel) => {
          this.users = data.GlobalEmployeeDetails;
        });
        this.visiblMessagePopup = false;
      },
        (response) => {
          this.visiblMessagePopup = false;
          this.visiblErrorPopup = true;
          this.errorMessage = response.error.Message;
        });
    }
  }
  syncUser(user: IGlobalEmployeeDetailModel) {
    if (this.readWriteAccessData == true) {
      this.userService.syncUser(user)
        .then((res) => {
          this.toasterService.success('Profile synced successfully');
          this.userSyncAction.emit(res);
        }
        );
    }
  }
  async downloadExcel(excelFLag: DownloadExcel) {
    const date = new Date().toISOString().slice(0, 10);
    if (excelFLag === this.excelEnum.ExportFilterMappingsEnabled)
      this.exportExcelService.excelfileCreationFromJson(this.containerMapping, `A&A People Feed ApplicationContainerMapping_${date}.xlsx`, 'Container Mapping', true, false);
    else if (excelFLag === this.excelEnum.ExportBaseMappingEnabled) {
      this.exportExcelService.excelfileCreationFromJson(this.baseMapping, `A&A People Feed BaseMapping_${date}.xlsx`, 'Base Mapping');
    }
    else if (excelFLag === this.excelEnum.OnBoardedAppsEnabled)
      this.exportExcelService.excelfileCreationFromJson(this.onBoardedApps, `A&A People Feed OnBoardedApps_${date}.xlsx`, 'OnBoarded Apps', false, false);
  }
}
